import { useNavigate } from "react-router-dom";

import {
  DEAD_ACCOUNT_REBIRTH_PATH,
  PLAYMAFIA_CREATE_ACCOUNT_URL,
} from "@/constants/deadAccount";
import DeadAccountFullscreenLayout from "../DeadAccountFullscreenLayout";
import DeadAccountScreen from "../DeadAccountScreen";

const DeadAccountFullscreenGate = () => {
  const navigate = useNavigate();

  return (
    <DeadAccountFullscreenLayout centered>
      <DeadAccountScreen
        variant="fullscreen"
        onRebirthClick={() => navigate(DEAD_ACCOUNT_REBIRTH_PATH)}
        onUnstakeClick={() => navigate("/rank-activation")}
        onCreateAccountClick={() => {
          window.location.href = PLAYMAFIA_CREATE_ACCOUNT_URL;
        }}
      />
    </DeadAccountFullscreenLayout>
  );
};

export default DeadAccountFullscreenGate;
